import React from 'react';
import routes from '../../router/AppRoutes';
import Router from '../../router/Router';
import ScrollToTopWithRouter from '../../router/ScrollToTopWithRouter';
import BackToTop from '../../components/BackToTop/BackToTop';

const PublicLayout = () => {
    
    const getPublicRoutes = () => {
        return routes.filter((route) => route.layout === '');
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", width: "100%", margin: 0, padding: 0 }}>
            <div style={{ flexShrink: 0, position: "relative", zIndex: 100, display: "block", margin: 0, padding: 0, lineHeight: 0, verticalAlign: "top" }}>
                <mitur-topbar style={{ display: "block", margin: 0, padding: 0, verticalAlign: "top" }}></mitur-topbar>
            </div>
            <ScrollToTopWithRouter>
                <Router routes={getPublicRoutes()}/>
            </ScrollToTopWithRouter>
            <BackToTop />
        </div>
    );
}

export default PublicLayout;